<template>
  <div id="property-modal" class="modal"  v-show="modalShown">
    <div class="modal-main modal-client-list">
      <dd-client-modal
        ref="clientModalRef"
        @getClientList="getClientList"
      />
      <div class="title-area" id="modal-moving">
        <div
          class="cross_btn"
          @click="modalShown = false"
        >
          <span class="css-cancel"></span>
        </div>
        <h2>顧客担当者管理</h2>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="openClientModal">新規登録</button>
      </div>
      <div class="data-area">
        <table>
          <thead>
            <tr>
              <th>顧客コード</th>
              <th>顧客会社名</th>
              <th>顧客支店名</th>
              <th>顧客部署名</th>
              <th>顧客担当者コード</th>
              <th>顧客担当者名</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(client, index) in clientPersonList" :key ="index">
              <td>{{ client.ccorpClientCd }}</td>
              <td>{{ client.ccorpClientName }}</td>
              <td>{{ client.ccorpClientBranchName }}</td>
              <td>{{ client.ccorpClientDepartmentName }}</td>
              <td>{{ client.ccorpClientPersonCd }}</td>
              <td>{{ client.ccorpClientPersonName }}</td>
              <td>
                <button class="main_btn" @click="openClientEditModal(client)">顧客担当者設定</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import ClientModal from '../modal/ClientModal'
export default {
  name: 'ClientListModal',
  components: {
    'dd-client-modal': ClientModal
  },
  props: {
    clientPersonList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
    },
    /** 担当者新規モーダルを開く */
    openClientModal: function () {
      this.$refs.clientModalRef.showNewModal()
    },
    /** 担当者編集モーダルを開く */
    openClientEditModal: function (data) {
      this.$refs.clientModalRef.showEditModal(data)
    },
    /** テーブルの更新 */
    getClientList: function (data) {
      this.$emit('getPropertyList')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-main .modal-client-list{
  max-height: 100%;
}
 .modal-client-list{
    max-width: 900px;
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/ClientListModal.vue